import { createRotateMatrix, sizeAfterTransform } from '@imagise/shared';

export interface Point2D {
  x: number;
  y: number;
}

export interface Size2D {
  width: number;
  height: number;
}

export interface Rectangle extends Point2D, Size2D {}

/**
 * Returns the bounding-box size of the given size rotated by the angle.
 *
 * @param size - Size to rotate
 * @param angleDeg - Rotation angle in degrees
 * @returns Size of the axis-aligned bounding box after rotation
 */
export function rotateSize(size: Size2D, angleDeg: number): Size2D {
  const rotated = sizeAfterTransform(size.width, size.height, createRotateMatrix(angleDeg));
  return { width: rotated.x, height: rotated.y };
}

/**
 * Normalizes a rectangle so that width and height are non-negative,
 * moving the origin to the top-left corner if needed.
 *
 * @param rect - Rectangle to normalize, possibly with negative dimensions
 * @returns Normalized rectangle, or null when the input is null
 */
export function normalizeRect(rect: Rectangle | null): Rectangle | null {
  if (!rect) return null;
  return {
    x: Math.min(rect.x, rect.x + rect.width),
    y: Math.min(rect.y, rect.y + rect.height),
    width: Math.abs(rect.width),
    height: Math.abs(rect.height),
  };
}
